import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';

import { getScreenWidth } from '@/utils';
import Placeholder from '@/components/Placeholder';
import { TABLET_L } from '@/constants';
import Image from '@/components/ContentfulImage';
import {
  RecommendedListWrap,
  RecommendedItem,
  ItemInfomationWrap,
  ItemImage,
  ItemTitle,
  ItemCaption,
  ItemDetailLink,
} from '@/pages/HairDiagnosis/HairDiagnosisResultPage/HomeCareResult/HomeCareResult.style';

const HomeCareResult = ({ copy, homeCareResult, locale, screenSize }) => (
  <RecommendedListWrap>
    <RecommendedItem>
      <ItemImage>
        {(!!(homeCareResult && _.get(homeCareResult, 'homeCareImage')) && (
          <Image
            src={homeCareResult.homeCareImage}
            options={{
              w: screenSize > TABLET_L ? '525px' : `${screenSize - 40}px`,
              h: screenSize > TABLET_L ? '350px' : `${screenSize - 40}px`,
              size: screenSize > TABLET_L ? [0, 0, 525, 350] : [0, 0, screenSize - 40, screenSize - 40],
              objectFit: 'contain',
            }}
          />
        )) || <Placeholder w="500px" h="320px" />}
      </ItemImage>
      <ItemInfomationWrap>
        <ItemTitle>
          <p className="lead">{copy.home_care_item || <Placeholder w="50%" h="16px" />}</p>
          {(!!(homeCareResult && _.get(homeCareResult, 'name')) && <p className="title">{homeCareResult.name}</p>) || (
            <Placeholder w="300px" h="45px" />
          )}
        </ItemTitle>
        <ItemCaption>
          {(!!(
            homeCareResult &&
            _.get(homeCareResult, 'products') &&
            homeCareResult.products.length > 0 &&
            homeCareResult.products[0].description
          ) && <p>{homeCareResult.products[0].description}</p>) || <Placeholder w="300px" h="300px" />}
        </ItemCaption>
        <ItemDetailLink>
          {!(homeCareResult && _.get(homeCareResult, 'rangeLinkUrl')) ? (
            <Placeholder w="100%" h="100%" />
          ) : (
            <a href={`https://www.shiseido-professional.com/${locale}${homeCareResult.rangeLinkUrl}`}>
              {copy.product_detail_label || <Placeholder w="50%" h="16px" />}
            </a>
          )}
        </ItemDetailLink>
      </ItemInfomationWrap>
    </RecommendedItem>
  </RecommendedListWrap>
);

HomeCareResult.defaultProps = {
  copy: {},
  homeCareResult: {},
  screenSize: null,
};

HomeCareResult.propTypes = {
  copy: PropTypes.shape({}),
  locale: PropTypes.string.isRequired,
  homeCareResult: PropTypes.shape({}),
  // スクリーンサイズ
  screenSize: PropTypes.number,
};

const mapState = state => ({
  copy: state.siteOptions.siteCopyHairDiagnosisSummary,
  locale: state.locale,
  // スクリーンサイズを実寸で取得する
  screenSize: getScreenWidth(),
});

export default connect(mapState)(HomeCareResult);



// WEBPACK FOOTER //
// ./src/pages/HairDiagnosis/HairDiagnosisResultPage/HomeCareResult/index.js